import {
    FrontendConnectionStatusDto,
    ConnectionStatusEnumType,
    ConnectionStatusReportView,
} from '@mark43/cad-api';

export function convertCombinedConnectionStatusReportToFrontendConnectionStatusDto(
    report: ConnectionStatusReportView
): FrontendConnectionStatusDto {
    return {
        electronStatus: report.internetStatus.status,
        socketStatus: report.socketStatus.status,
        navigatorStatus: 'ONLINE',
        timestamp: report.timestamp,
        uuid: report.uuid,
    };
}

export function convertFrontendConnectionStatusDtoToCombinedConnectionStatusReport(
    dto: FrontendConnectionStatusDto
): ConnectionStatusReportView {
    return {
        internetStatus: {
            status: dto.electronStatus as ConnectionStatusEnumType,
            offlineSeconds: undefined,
        },
        socketStatus: {
            status: dto.socketStatus as ConnectionStatusEnumType,
            offlineSeconds: undefined,
        },
        timestamp: dto.timestamp,
        uuid: dto.uuid,
    };
}
